import React, { FC, useState } from "react";
import { UI_ModuleTextDownCard, UI_ModuleTitleCard } from "../../../../../../UI_ITO/indexUI";
import { DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { message } from "antd";
import { useParams } from "react-router-dom";
import {
  useChangeMemberUlMutation,
  useDeleteMemberUlMutation,
} from "../../../../../../store/api/applicationBankApi/juridical.api";
import { LegalEntitieInfo } from "../LegalEntitieInfo/LegalEntitieInfo";
import { ILegalEntityCard } from "../../../../../../interfaces/props/ILegalEntityCard";

import classes from "./style/LegalEntityCard.module.css";

export const LegalEntityCard: FC<ILegalEntityCard> = (props) => {
  const { inn, shortname,  ul_id, percent, isOpen } = props;
  const { applicationBankId } = useParams();
  const [isEdit, setIsEdit] = useState(false);
  const [deleteMemberUl] = useDeleteMemberUlMutation();
  const [changeMemberUl, { isLoading: isChangeLoading }] =
    useChangeMemberUlMutation();
  const [collapseIsOpen, setCollapseIsOpen] = useState(isOpen ?? false);

  const handleEditForm = () => {
    setIsEdit(!isEdit);
  };
  const handleCollapse = () => setCollapseIsOpen((prev) => !prev);

  const deleteLegalEntity = () => {
    if (applicationBankId && ul_id) {
      deleteMemberUl({ applicationBankId, ul_id: ul_id });
    }
  };

  const changeLegalEntity = async (value: { percent: number }) => {
    if (!applicationBankId || !ul_id) {
      message.error("Некорректные данные для изменения учредителя");
      return;
    }
    try {
      await changeMemberUl({
        applicationBankId: Number(applicationBankId),
        ul_id,
        percent: value.percent,
      }).unwrap();
      handleEditForm();
      message.success("Учредитель изменён");
    } catch (error: any) {
      message.error(error?.data?.message || "Произошла ошибка");
    }
  };

  return (
    <div className={classes.legalEntityWrapper}>
      <UI_ModuleTitleCard
        title={shortname}
        icon={collapseIsOpen ? <UpOutlined onClick={handleCollapse} /> : <DownOutlined onClick={handleCollapse} />}
        iconAdditional={
          <DeleteOutlined style={{ color: "red" }}  onClick={deleteLegalEntity} />
        }
        className={`${classes.legalEntityCard} ${collapseIsOpen ? classes.open : ''}`}
        textDown={
          <>
            {percent && (
              <UI_ModuleTextDownCard
                textDown={[`ИНН ${inn}`, `Доля УК ${percent}%`]}
              />
            )}
          </>
        }
      />
      { collapseIsOpen && (
          <LegalEntitieInfo {...props} openOrCloseForm={handleCollapse} />
        )
      }
    </div>
  );
};
